var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"observedElement",staticClass:"h-6 w-full"})
}
var staticRenderFns = []

export { render, staticRenderFns }